import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../../utils/api';

// Create an API thunk for fetching data
export const fetchAllPlantData = createApi('ltDropDownData', 'GET');

const AdminScheduler = createSlice({
  name: 'AdminScheduler',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPlantData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPlantData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllPlantData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default AdminScheduler.reducer;